var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_891",
    "data-name": "Raggruppa 891",
    transform: "translate(-504 -231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_889",
    "data-name": "Raggruppa 889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_888",
    "data-name": "Raggruppa 888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_887",
    "data-name": "Raggruppa 887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_886",
    "data-name": "Raggruppa 886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Componente_65_2",
    "data-name": "Componente 65 \\u2013 2",
    transform: "translate(504 231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_871",
    "data-name": "Raggruppa 871",
    transform: "translate(-499 -218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_870",
    "data-name": "Raggruppa 870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_869",
    "data-name": "Raggruppa 869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Componente_64_1",
    "data-name": "Componente 64 \\u2013 1",
    transform: "translate(499 218)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_11",
    "data-name": "Ellisse 11",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#702180"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_230",
    "data-name": "Tracciato 230",
    d: "M52.7,270.512l-1.829-1.84a.74.74,0,0,1,0-1.038.729.729,0,0,1,1.034,0l1.311,1.319,3.5-3.527a.729.729,0,0,1,1.034,0,.74.74,0,0,1,0,1.038l-4.022,4.047a.727.727,0,0,1-1.034,0Z",
    transform: "translate(452.185 -42.474)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.c6a759e621427efbbdefaa5a37a780d7.svg";
export { ForwardRef as ReactComponent };